// CustomerRow.jsx
import React, { useState } from 'react';
import Classes from './Tickets.module.css';

import MoreDropDown from './MoreDropDown';
import DropDown from './StatusDropDown/DropDown';

export default function TableRow({ value, index }) {

  return (
    <>
      {/* Desktop view */}
      <div
        className={`${Classes.customerRow} ${value.status === 'disabled' ? Classes.disabledRow : ''
          }`}
        key={value._id}
      >
        {/* Name/Email */}
        <div className={`${Classes.customerInfo} ${Classes.colCustomer}`}>
          <h5 className="truncate">{value.subject}</h5>
        </div>
        {/* Spend */}
        <div className={`${Classes.spendings} ${Classes.colSpendings}`}>
          <h5>{value.date}</h5>
        </div>
        {/* Bookings */}
        <div className={`${Classes.bookings} ${Classes.colBookings}`}>
          <DropDown
            selectedValue={value.status}
            options={["Open", "Closed"]}
            onChange={(val) => value.status = val}
            isDropDown={false}
          />
        </div>
        {/* Date Joined */}
        <div className={`${Classes.dateJoined} ${Classes.colDate}`}>
          <MoreDropDown
            index={index}
            user={value}
          />
        </div>
        {/* <div className={`${Classes.disableToggle} ${Classes.colDisable}`}>
          <h5>{value.lastMessage}</h5>
        </div>
        <div className={`${Classes.actions} ${Classes.colActions}`}>
        </div> */}
      </div>
    </>
  );
}
